module.exports = __webpack_public_path__ + "static/media/10.5c2957b2.png";